import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import AnonymousLogin from "../../auth/anonymousLogin";
import VerifyEmail from "../../auth/anonymousLogin/VerifyEmail";
import {
  triggerSelfEnrolmentVerificationCode,
  setSelfEnrolmentDetails,
} from "../../../actions";
import { getSelfEnrolmentData } from "../../../selectors";
import { get } from "lodash";
import Login from "./components/Login";
import { InitialSelfEnrolmentState } from "./utilities/constants";

const MyComponent: React.FC = () => {
  const dispatch = useDispatch();
  dispatch(setSelfEnrolmentDetails(InitialSelfEnrolmentState));

  return (
    <div>
      <Login />
    </div>
  );
};

export default MyComponent;
